// Productgalerij zoals monavida.nl (Impact): het kader is zo hoog als de foto die je ziet, niet als de hoogste foto
// van het product (Horizon "adapt"). Bij het openen is dat de eerste foto; bij een andere foto schuift de hoogte mee.
// Gemeten 23 okt 2026: Snatched (eerste foto 3:4, een paar van 0,72) staat op NL op 500 hoog, US stond op 521.
const KADER = '.product-information media-gallery slideshow-slides';

function actieveDia(kader) {
  return kader.querySelector('slideshow-slide[aria-hidden="false"]') || kader.querySelector('slideshow-slide');
}

function zetHoogte(kader, dia = actieveDia(kader)) {
  if (!dia) return;
  const hoogte = dia.getBoundingClientRect().height;
  if (hoogte > 0) kader.style.setProperty('--mv-dia-hoogte', `${hoogte}px`);
}

function start() {
  for (const kader of document.querySelectorAll(KADER)) {
    zetHoogte(kader);
    // alleen bij een andere breedte (draaien, venster): de eigen hoogtewijziging hoeft niet opnieuw
    let breedte = kader.clientWidth;
    new ResizeObserver(() => {
      if (kader.clientWidth === breedte) return;
      breedte = kader.clientWidth;
      zetHoogte(kader);
    }).observe(kader);
  }
}

document.addEventListener('slideshow:select', (event) => {
  const kader = event.target instanceof Element ? event.target.querySelector(KADER.split(' ').pop()) : null;
  // de dia uit het event: aria-hidden is op dat moment soms nog niet bijgewerkt
  const dia = event.detail?.slide instanceof Element ? event.detail.slide : undefined;
  if (kader && kader.matches(KADER)) requestAnimationFrame(() => zetHoogte(kader, dia));
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
